import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { deleteContractorDocument, downloadContractorDocument } from '../../services/contractorsService';
import styles from './DocumentsSection.module.css';

const DocumentsSection = ({ contractor, onDocumentRemoved }) => {
  // Debug: Log documents when component receives contractor prop
  useEffect(() => {
    if (contractor && contractor.documents) {
      console.log(`📄 DocumentsSection: Received ${contractor.documents.length} documents for contractor ${contractor.id}`);
      if (contractor.documents.length > 0) {
        console.log(`📄 Document details:`, contractor.documents.map(d => ({
          id: d.id,
          name: d.name,
          file: d.file,
          documentable_type: d.documentable_type
        })));
      }
    }
  }, [contractor]);

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB');
  };

  const handleDownloadDocument = async (documentId, documentName, e) => {
    e.preventDefault(); // Prevent navigation to edit page
    e.stopPropagation(); // Stop event bubbling
    
    try {
      console.log(`⬇️ Downloading document: ${documentName} (ID: ${documentId})`);
      const response = await downloadContractorDocument(contractor.id, documentId);
      if (response && response.success) {
        toast.success(response.message || 'Document downloaded successfully');
      } else {
        toast.error(response?.message || 'Failed to download document');
      }
    } catch (error) {
      console.error('Error downloading document:', error);
      toast.error(error.message || 'Failed to download document. Please try again.');
    }
  };

  const handleRemoveDocument = async (documentId) => {
    if (window.confirm('Are you sure you want to remove this document?')) {
      try {
        const response = await deleteContractorDocument(contractor.id, documentId);
        if (response && response.success) {
          toast.success('Document removed successfully');
          if (onDocumentRemoved) {
            onDocumentRemoved(documentId);
          }
        } else {
          const errorMessage = response?.message || 'Failed to remove document';
          toast.error(errorMessage);
          console.error('Failed to remove document:', response);
        }
      } catch (error) {
        console.error('Error removing document:', error);
        toast.error(error.message || 'Error removing document. Please try again.');
      }
    }
  };

  return (
    <div className={styles.colMd12}>
      <div className={styles.panelTitle}>
        <h3>Documents</h3>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Link 
            to={`/contractors/${contractor.id}/documents/create`} 
            className={styles.btnSecondary}
          >
            <i className={styles.glyphiconPlus}></i> Add documents
          </Link>
        </div>
      </div>

      <div className={styles.panelGroup}>
        <div className={styles.row}>
          {contractor.documents && contractor.documents.length > 0 ? (
            contractor.documents.map((document) => (
              <div key={document.id} className={styles.colXs12}>
                <div 
                  className={styles.btnProperty}
                  onClick={(e) => handleDownloadDocument(document.id, document.file || document.name, e)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className={styles.documentLeft}>
                    <img src="/images/pdf.png" alt="PDF" />
                  </div>
                  <div className={styles.documentRight}>
                    <p className={styles.btnTitle}>{document.name || document.file || 'Untitled Document'}</p>
                    <p className={styles.btnShort}>
                      <span>Uploaded: </span>
                      {formatDate(document.date_uploaded)}
                    </p>
                  </div>
                </div>
                <div className={styles.clearfix}></div>
                <div className={styles.documentActions}>
                  {/* Laravel equivalent: Only show Edit if reminder_sent == 0 (line 33 of _documents.blade.php) */}
                  {document.reminder_sent === 0 && (
                    <Link
                      to={`/contractors/${contractor.id}/documents/${document.id}/edit`}
                      className={styles.hiddenPrintLink}
                    >
                      <div className={`${styles.documentAction} ${styles.documentActionLeft} ${styles.documentActionEdit} ${styles.hiddenPrint}`}>
                        Edit
                      </div>
                    </Link>
                  )}
                  <button
                    className={`${styles.documentAction} ${styles.documentActionRight} ${styles.documentActionDelete} ${styles.hiddenPrint}`}
                    onClick={() => handleRemoveDocument(document.id)}
                    data-confirm-action="Are you sure you want to remove?"
                  >
                    Remove
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className={styles.colXs12}>
              <p className={styles.noDocuments}>No documents found</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DocumentsSection; 